var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m507.607 216.525c5.857-5.857 5.857-15.355 0-21.213l-190.917-190.918c-5.858-5.858-15.355-5.858-21.213 0l-74.247 74.245 212.131 212.133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.616 485.616c17.015-17.015 26.386-39.607 26.385-63.615 0-17.983 29.222-54.182 59.105-66.561 8.643-3.579 20.426-6.366 27.48.688 7.406 7.404 8.171 8.171 8.197 8.196.028.029.057.059.086.087 11.298 11.298 26.365 17.52 42.428 17.52 16.06-.001 31.128-6.224 42.426-17.522l52.426-52.425-212.131-212.132-52.427 52.427c-11.298 11.298-17.521 26.365-17.521 42.428 0 16.061 6.222 31.128 17.535 42.442.042.042.632.63 8.27 8.267 2.996 2.997 4.393 6.674 4.393 11.572 0 29.428-46.683 75.013-70.267 75.013-49.624-.001-89.999 40.372-90.001 89.998v.002c.001 24.009 9.372 46.601 26.387 63.613 17.014 17.016 39.606 26.386 63.614 26.386s46.601-9.37 63.615-26.384zm-78.616-63.616c0-8.284 6.716-15 15-15s15 6.716 15 15-6.716 15-15 15-15-6.715-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.621214f7cf9cf36673df264237daa7af.svg";
export { ForwardRef as ReactComponent };